import "typeface-lora"
import "typeface-lato"
import "prism-themes/themes/prism-vsc-dark-plus.css"
// import "prismjs/themes/prism.css"
import "./src/css/style.css"
